export default {
  pagination: {
    goto: 'Перейти',
    page: '',
    itemsPerPage: ' / стр.',
    total: (total) => `Всего: ${total}`,
    prev5: 'Предыдущие 5 страниц',
    next5: 'Следующие 5 страниц',
  },
  table: {
    confirmFilter: 'Подтвердить',
    resetFilter: 'СБросить',
  },
}
